<template>
  <div class="base-text-animation-1">
    <div ref="stripe" class="stripe"/>
    <div ref="text">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { TimelineMax, Power1, Power4 } from 'gsap'
export default {
  data () {
    return {
      tl: null
    }
  },
  mounted () {
    this.tl = this.createTl()
  },
  methods: {
    createTl () {
      const tl = new TimelineMax({ paused: true })
      tl.from(this.$refs['text'], 0.4, { autoAlpha: 0, xPercent: 30, ease: Power1.easeOut }, '0')
      tl.from(this.$refs['stripe'], 0.4, { scaleX: 0, transformOrigin: '0% 50%', ease: Power4.easeOut }, '+=0')
      tl.to(this.$refs['stripe'], 0.4, { scaleX: 0, transformOrigin: '100% 50%', ease: Power4.easeOut }, '+=0')
      return tl
    }
  }
}
</script>

<style lang="scss" scoped>
.base-text-animation-1 {
  position: relative;
}
.stripe {
  position: absolute;
  width: 105%;
  left: 50%;
  height: 80%;
  top: 50%;
  transform: translateY(-50%) translateY(-0.03em) translateX(-50%);
  background: var(--color-red-1);
  mix-blend-mode: screen;
  will-change: transform;
  opacity: 1;
}
</style>
